<template>
  <div class="auth-wrapper">
    <NotificationsPanel v-if="isNotificationsPanelEnabled" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import NotificationsPanel from '@monolith/legacy/components/notifications/notifications-panel.vue';
import { getGlobalConfig } from '@monolith/legacy/services/global-config';
import { useStore } from '@core/composables/use-store';
import { isEnabled } from '@monolith/legacy/services/features';

// MXB-2597: the "My lists" heart button has moved into the retailer account dropdown
// (rendered from authBlock.blade.php). This wrapper now only hosts the notifications panel.
export default defineComponent({
  name: 'AuthWrapper',
  components: {
    NotificationsPanel,
  },
  setup() {
    const store = useStore();

    const user = computed(() => {
      return store.getters.user;
    });

    const isNotificationsPanelEnabled = computed(() => {
      const { braze } = getGlobalConfig();
      return (isEnabled('comms.tgcs_45') || isEnabled('comms.tgcs_117')) && braze?.api_key && braze?.base_url && user.value;
    });

    return {
      isNotificationsPanelEnabled,
    };
  },
});
</script>

<style scoped lang="scss">
.auth-wrapper {
  @apply ds-mr-4 ds-flex ds-gap-4;
}
</style>
